import React, { Component} from 'react';
import * as constants from '../config/constants';
import axios from 'axios';

class Bulk extends Component {
	constructor() {
		super();
		this.state = {
			associates: []
		}
	}
	componentDidMount() {
		let associates = [
		{
			"employeeId": "EBA16267",
			"name": "Keerthana Dandin",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16264",
			"name": "Sai Mohan B",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16266",
			"name": "Purnima R Tuppad",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16265",
			"name": "Shudhanshu Kumar",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16248",
			"name": "D V Dhathri",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16247",
			"name": "C H Balasaisree",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16246",
			"name": "C Gamanika",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16245",
			"name": "Sahana Sriram",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16252",
			"name": "M Kalyani",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16251",
			"name": "K N V Gopikrishna",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16250",
			"name": "G Saikomali",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16249",
			"name": "G Avinash",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16258",
			"name": "R Sailohitha",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16255",
			"name": "S Ramya",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16254",
			"name": "S Anusuya",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16253",
			"name": "S Ajith Kumar",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16262",
			"name": "Krishna Kamal Moral",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16263",
			"name": "Harshitha V",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16261",
			"name": "Pragna C P",
			"department": "ETHNUS"
		},
		{
			"employeeId": "EBA16260",
			"name": "Anusha S Kotagi",
			"department": "ETHNUS"
		}
		];
		associates.map(function(a, i) {
			let request={
				name: associates[i].name,
				email: "admin+" + (i+100) + "@ethnus.com",
				department: associates[i].department,
				employeeId: associates[i].employeeId,
			}
			let that = this;
			axios.post( constants.API_BASE_URL + "user", request)
			.then(function (response) {
				let copied = Object.assign({}, that.state);
				copied.associates.push(response);
				that.setState(copied);
			})
			.catch(function (error) {
			});
		})
	}
	render = () => {
		return (<div>{JSON.stringify(this.state.associates)}</div>)
	}
}

export default Bulk;


// WEBPACK FOOTER //
// ./src/associates/bulk.js